import React, { useState } from "react";
import "./SideBar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandPeace, faRefresh } from "@fortawesome/free-solid-svg-icons";
import toast, { Toaster } from "react-hot-toast";
import { addToDb, deleteShoppingCart } from "../fakeDb/fakeDb";
import {
  runFireworks,
  runSchoolPride,
  runStars,
  runRealisticLook,
  runStarsReset //! reset action ar jonno
} from "../../../src/components/utilitys/utils";



//toast
const notify = () =>
  toast(
    "Congratulation !! You Done it.. 👍👍",
    {
      icon: "👏👏 ",
      style: {
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    },
    deleteShoppingCart()
  );



const SideBar = (props) => {
  const { cart, clearCart } = props;
  console.log(cart);

  let total = 0; // ata total price dekhabe--
  let rest = 0;

  for (const exercise of cart) {
    total = total + exercise.time;
    rest = rest + exercise.rest;
  }

  //add a break ar jonno amader id nite hobe --
  const addBreaks = [
    {
      id: "001",
      value: 30,
    },
    {
      id: "002",
      value: 60,
    },
    {
      id: "003",
      value: 90,
    },
    {
      id: "004",
      value: 120,
    },
    {
      id: "005",
      value: 150,
    },
  ];

  const [brk, setBrk] = useState([]);

  const clearBrk = () => {
    setBrk([]);
    deleteShoppingCart();
  };
  //jekhane state ase shekhane clear korte hobe setfunction hobe empty array.











  //button a -- event handler for add break.
  const handleAddToBreak = (addBreak) => {
    console.log(addBreak);
    // don't use it ("addBreak")--ok
    // const newBreak = [...brk, addBreak]; //ata single rakhlam
    const newBreak = [addBreak];
    setBrk(newBreak);
    addToDb(addBreak.id);
  };

  let breakset = 0; // ata total price dekhabe--
  for (const addBreak of brk) {
    breakset = breakset + addBreak.value;
  }

  const grandTotal = (total + rest + breakset) / 60;

  //   event handler✨✨✨✨✨✨✨✨✨✨✨
  const handleActivityReset = () => {
    console.log("click");
    clearCart();
    clearBrk();
    deleteShoppingCart();
    runStarsReset();

    toast.success("Ok.. All is Reset..✨✨✨ ")
  };

  //   event handler✨✨✨✨✨✨✨✨✨✨✨
  const handleCompleteActivity = () => {
    console.log("click");
    clearCart();
    clearBrk();
    notify();
    runFireworks();
    runSchoolPride();
    runStars();
    runRealisticLook();


  };

  return (
    <div className="cart">
      <div className="info">
        <div>
          <div className="large-text">
            70<span className="small-text">kg</span>
          </div>
          <div>Weight</div>
        </div>
        <div>
          <div className="large-text">
            5.75<span className="small-text">ft</span>
          </div>
          <div>Height</div>
        </div>
        <div>
          <div className="large-text">
            28<span className="small-text">yrs</span>
          </div>
          <div>Age</div>
        </div>
      </div>

      <h2>Add A Break</h2>
      <div className="info">
        {addBreaks.map((addBreak) => (
          <button
            disabled={breakset >= 300}
            className="break-button"
            onClick={() => handleAddToBreak(addBreak)}
            key={addBreak.id}
          >
            {addBreak.value}
          </button>
        ))}
      </div>

      <div className="exercise">
        <h2>Exercise Details</h2>
        <h4>Slected Exercise: {cart.length}</h4>
        <h4>Exercise Time: {total} sec</h4>
        <h4>Rest Time: {rest} sec</h4>
        <h4 className="text-red">Add A Break: {breakset} sec</h4>
        <p className="condition">** Select only one break time.</p>

        <h3>Total Time: {grandTotal} min </h3>
      </div>

      <div className="activity">
        <button

          disabled={total === 0 && breakset <= 0}
          onClick={handleCompleteActivity}
          className="btn-activity"
        >
          <p className="btn-text">Activity Completed</p>
          <span>
            <FontAwesomeIcon icon={faHandPeace}></FontAwesomeIcon>
          </span>
          <Toaster />
        </button>
      </div>

      <div className="reset">

        <button
          onClick={handleActivityReset}

          disabled={total === 0 && breakset <= 0}
          className="btn-activity">
          <p className="btn-text">Activity Reset</p>
          <span>
            <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
          </span>
        </button>
      </div>

      {/* no need, mention in the above */}
      {/* <div>
         <button onClick={clearCart}>clearCart</button>
      </div> */}
    </div>
  );
};

export default SideBar;
